/*!
 * AGL DLS Components built with Stencil
 */
export const basicSizeOptions = ['sm', 'md', 'lg'];
export const extendedSizeOptions = ['xs', 'xl'];
export const otherFontSizeTypes = ['display01', 'display02'];
export const fontOptions = ['fontfamily01', 'fontfamily02'];
export const basicAppearanceOptions = ['inverse', 'default'];
const otherAppearanceOptions = ['muted', 'highlight', 'highlight-secondary'];
export const appearanceOptions = [...basicAppearanceOptions, ...otherAppearanceOptions];
export const headingOptions = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export const titleOptions = ['title1', 'title2', 'title3', 'title4', 'title5', 'title6'];
export const fontWeightOptions = ['inherit', 'semibold', 'regular'];
export const spaceOptions = ['space00', 'space01', 'space02', 'space03', 'space04', 'space05', 'space06'];
export const topMarginOptions = ['none', ...spaceOptions];
export const iconSizeOptions = ['sm', 'md', 'lg', 'xl'];
export const statusOptions = ['warning', 'information', 'error'];
export const paddingOptions = ['sm', 'md', 'lg'];
export const illustrationSizeOptions = [...basicSizeOptions, ...extendedSizeOptions];
export const elevationOptions = ['level0', 'level1'];
export const bannerHeightOptions = ['sm', 'lg'];
export const ColumnModifierOptions = [
  'visible-sm-only',
  'visible-md-only',
  'visible-lg-only',
  'hidden-sm',
  'hidden-md',
  'hidden-lg',
  'hidden'
];
// export type ColumnModifierType = typeof ColumnModifierOptions[number];
//This can be added to as required. We don't necessarily want to allow all attributes
export class AriaAttributes {
}
